import 'luxon';

/**
 * Add a schema to a url with an ambiguous schema (`//`) (default is `https`).
 *
 * ```
 * ensureSchema('//cdn.invitae.com/i/123') === 'https://cdn.invitae.com/i/123'
 * ```
 */
var ensureSchema = function (url, schema) {
    if (schema === void 0) { schema = 'https'; }
    if (url)
        return url.startsWith('//') ? "".concat(schema, ":").concat(url) : url;
    return '';
};
/**
 * Construct a URL query string from a given object.
 */
var queryStringFrom = function (params) {
    return Object.entries(params)
        .map(function (parts) { return parts.map(encodeURIComponent).join('='); })
        .join('&');
};
/**
 * Add a query parameter to a given URL to make Contentful return the image as a JPG.
 */
var ensureCorrectPreviewImageUrl = function (url) { return "".concat(url, "?").concat(queryStringFrom({ fm: 'jpg' })); };
// determine whether the code is being run in the browser or on the server
var isServer = function () { return typeof process !== 'undefined' && typeof process.versions.node !== 'undefined'; };
/**
 * @param list - list that should be cleared from undefined or null
 */
var clearListfromUndefinedOrNull = function (list) {
    return list.filter(function (item) { return !!item || item === null; });
};
// String.endsWith analog with IE support
var endsWith = function (str, suffix) {
    return str.indexOf(suffix, str.length - suffix.length) !== -1;
};
var getPixelsBasedOnColumns = function (numberOfColumns, gap) {
    if (numberOfColumns === void 0) { numberOfColumns = 1; }
    if (gap === void 0) { gap = 30; }
    var CONTAINER_WIDTH = 1230;
    var COLUMNS_TOTAL = 12;
    var totalGap = gap * (numberOfColumns - 1);
    var pixelPerColumn = CONTAINER_WIDTH / COLUMNS_TOTAL;
    return Math.ceil(pixelPerColumn * numberOfColumns + totalGap);
};

export { clearListfromUndefinedOrNull, endsWith, ensureCorrectPreviewImageUrl, ensureSchema, getPixelsBasedOnColumns, isServer, queryStringFrom };
//# sourceMappingURL=misc.esm.js.map
